module.exports = __webpack_public_path__ + "static/bentonsans-bold-webfont-93a19913df57ace0a6044161c5dcaddc.woff";